import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  get enableFirms(): boolean {
    return environment.enableFirms;
  }

  get enableIndividuals(): boolean {
    return environment.enableIndividuals;
  }
}